import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';
const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const token = localStorage.getItem('sf_token');
    const savedUser = localStorage.getItem('sf_user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      API.get('/api/auth/me').then(res => setUser(res.data.user)).catch(() => logout()).finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);
  const loginWithGoogle = async (credential) => {
    const res = await API.post('/api/auth/google', { credential });
    const { token, user } = res.data;
    localStorage.setItem('sf_token', token);
    localStorage.setItem('sf_user', JSON.stringify(user));
    setUser(user); return user;
  };
  const requestMagicLink = async (email) => {
    const res = await API.post('/api/auth/magic-link/request', { email });
    return res.data.message;
  };
  const loginWithMagicLink = async (magicToken) => {
    const res = await API.post('/api/auth/magic-link/verify', { token: magicToken });
    const { token, user } = res.data;
    localStorage.setItem('sf_token', token);
    localStorage.setItem('sf_user', JSON.stringify(user));
    setUser(user); return user;
  };
  const logout = () => { localStorage.removeItem('sf_token'); localStorage.removeItem('sf_user'); setUser(null); };
  return <AuthContext.Provider value={{ user, loading, loginWithGoogle, requestMagicLink, loginWithMagicLink, logout }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => useContext(AuthContext);
